export enum KpiEAETypes {
  'LOAD_REQUEST' = '@kpiEAE/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@kpiEAE/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@kpiEAE/LOAD_FAILURE',
}

export interface IPoint {
  time: string;
  value: number;
}

export interface IKpi {
  card: string;
  data: IPoint[];
  protocolos: number[];
  qtd: number;
  total: number;
  percentual: number;
}

export interface KpiEAEState {
  readonly data: IKpi[];
  readonly error: boolean;
  readonly loading: boolean;
}
